import React from 'react';

/**
 * Tailwind toggle switch.
 * labelPosition: 'inline' (default) — label beside toggle on one line.
 *                'above' — label above, toggle below (matches form field layout).
 */
const Switch = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  size = 'md',
  labelPosition = 'inline',
}) => {
  const dims =
    size === 'sm'
      ? { track: 'h-4 w-7', thumb: 'h-3 w-3', shift: 'translate-x-3' }
      : { track: 'h-5 w-9', thumb: 'h-4 w-4', shift: 'translate-x-4' };

  const toggle = (
    <span className="relative inline-flex items-center">
      <input
        type="checkbox"
        className="peer sr-only"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange && onChange(e, e.target.checked)}
      />
      <span
        className={`${dims.track} rounded-full bg-slate-300 transition-colors peer-checked:bg-[#0061B2] peer-focus-visible:ring-2 peer-focus-visible:ring-[#0061B2]/30`}
      />
      <span
        className={`absolute left-0.5 ${dims.thumb} rounded-full bg-white shadow transition-transform ${
          checked ? dims.shift : 'translate-x-0'
        }`}
      />
    </span>
  );

  if (labelPosition === 'above') {
    return (
      <div className={disabled ? 'cursor-not-allowed opacity-60' : ''}>
        {label && (
          <span className="mb-1 block text-[13px] font-medium text-[#212B36]">{label}</span>
        )}
        {toggle}
      </div>
    );
  }

  return (
    <label
      className={`inline-flex items-center gap-2 ${
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      }`}
    >
      {toggle}
      {label && <span className="text-sm text-[#212B36]">{label}</span>}
    </label>
  );
};

export default Switch;
